import Vue from 'vue'
import Router from 'vue-router'
import utils from "@/services/utils";

Vue.use(Router);

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/:office/pages',
            component: () => import('@/views/pages/Index.vue'),
            children: [
                {
                    name: 'Login',
                    path: 'login',
                    component: () => import('@/components/Login.vue'),
                },
            ],
        },
        {
            path: '/',
            component: () => import('@/views/dashboard/Index.vue'),
            children: [
                {
                    name: 'Dashboard',
                    path: '',
                    component: () => import('@/views/dashboard/Dashboard.vue'),
                },
                // Pages
                {
                    name: 'User Profile',
                    path: 'pages/user',
                    component: () => import('@/views/dashboard/pages/UserProfile.vue'),
                },
                {
                    name: 'Periods',
                    path: 'periods',
                    component: () => import('@/components/PeriodsList.vue'),
                },
                {
                    name: 'Choose Patients',
                    path: 'periods/:periodId',
                    component: () => import('@/components/ChoosePatientsForm.vue'),
                    props: true,
                },
                {
                    name: 'calendarUserList',
                    path: 'calendar/:userType',
                    component: () => import('@/components/UserList.vue'),
                    props: true,

                },
                {
                    name: 'automatic-scheduler',
                    path: 'automatic-scheduler',
                    component: () => import('@/components/AutomaticScheduler.vue'),
                    props: true,

                },
                {
                    name: 'summary-scheduler',
                    path: 'summary/summary-scheduler',
                    component: () => import('@/components/SummaryScheduler.vue'),
                    props: true,

                },
                {
                    name: 'Calendar',
                    path: 'calendar/:userType/:userId',
                    component: () => import('@/components/Scheduler.vue'),
                    props: true,
                },
                {
                    name: 'activity-list',
                    path: 'manage/activities',
                    component: () => import('@/components/ActivityList.vue'),
                    props: true,
                },
                {
                    name: 'party-list',
                    path: 'manage/:userType',
                    component: () => import('@/components/PartyList.vue'),
                    props: true,
                },
            ],
        },
        {
            path: '/unauthorized',
            component: () => import('@/views/pages/Index.vue'),
            children: [
                {
                    name: '403 Error',
                    path: '',
                    component: () => import('@/views/pages/Unauthorized.vue'),
                },
            ],
        },
        {
            path:'/logout',
            component: () => import("@/views/pages/Logout.vue")
        },
        {
            path: '*',
            component: () => import('@/views/pages/Index.vue'),
            children: [
                {
                    name: '404 Error',
                    path: '',
                    component: () => import('@/views/pages/Error.vue'),
                },
            ],
        },
    ],
});
router.beforeEach((to, from, next) => {

    const publicPages = ['/pages/login', '/unauthorized', '/pages/register'];
    const authRequired = publicPages.filter((it) => to.path.endsWith(it)).length === 0;
    const user = JSON.parse(<string>localStorage.getItem('user'));

    // try to access a restricted page + not logged in
    if (authRequired && utils.isNull(user)) {
        return next('/unauthorized');
    }

    next();
});
export default router;


